<style>
.ribbon-button input {
  font-size: 10px;
}
.ribbon--dropdown {
  font-size: 12px;
}
#modelWat__scrollbar .ribbon--dropdown {
  padding-top: 24px !important;
}
.ol-popup {
  position: absolute;
  background-color: white;
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  width: auto;
}
.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.popup__content > li {
  width: 240px;
  display: flex;
  justify-content: space-between;
}
.popup__content > li:not(:last-child) {
  border-bottom: 1px solid lightgrey;
}
.btnInactive {
  pointer-events: none !important;
  background-color: lightgray !important;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{ suppressScrollY: true }"
    ref="bar-element"
    id="modelWat__scrollbar"
  >
    <div id="popup" class="ol-popup">
      <div id="popup-content"></div>
    </div>
    <!-- <div class="group">
      <button
        class="ribbon-button"
        @click="show('legendModal')"
        title="Legenda mapy"
      >
        <span class="icon">
          <v-icon>layers</v-icon>
        </span>
        <span class="caption">WARSTWY</span>
      </button>
    </div> -->
    <div class="group">
      <button
        class="ribbon-button"
        title="Parametry modelowania"
        @click="show('modelingParametersModal')"
      >
        <span class="icon">
          <v-icon>settings</v-icon>
        </span>
        <span class="caption">Parametry modelowania</span>
      </button>
    </div>
    <div class="group">
      <div class="container__group--rows">
        <div class="ribbon__row border--bottom" @click="checkGraph">
          <div class="ribbon-button ribbon__row--flex">
            <span class="icon">
              <v-icon small>thumb_up_alt</v-icon>
            </span>
            <button class="caption">Sprawdź poprawność sieci</button>
          </div>
        </div>
        <div class="ribbon__row border--bottom">
          <div @click="exportGraph" class="ribbon-button ribbon__row--flex">
            <span class="icon">
              <v-icon small>ballot</v-icon>
            </span>
            <button class="caption">Eksport grafu sieci</button>
          </div>
        </div>
      </div>
    </div>
    <div class="group">
      <div class="container__group--rows">
        <div class="ribbon__row border--bottom" @click="doModelling">
          <div class="ribbon-button ribbon__row--flex">
            <span class="icon">
              <v-icon small>build</v-icon>
            </span>
            <button class="caption">Modeluj</button>
          </div>
        </div>
        <div class="ribbon__row border--bottom">
          <div
            @click="show('virtualRecipientsRegisterModal')"
            class="ribbon-button ribbon__row--flex"
          >
            <span class="icon">
              <v-icon small>person</v-icon>
            </span>
            <button class="caption">Projektowani odbiorcy</button>
          </div>
        </div>
      </div>
    </div>
    <div class="group">
      <button class="ribbon-button" @click="show('CurvesModal')">
        <span class="icon">
          <v-icon>show_chart</v-icon>
        </span>
        <span class="caption">Wzorce i krzywe</span>
      </button>
    </div>

    <div class="group">
      <div class="container__group--rows">
        <div
          class="ribbon__row border--bottom"
          @click="showEPANETControls('SIMPLE')"
        >
          <div class="ribbon-button ribbon__row--flex">
            <span class="icon">
              <v-icon small>view_stream</v-icon>
            </span>
            <button class="caption">Sterowanie proste</button>
          </div>
        </div>
        <div class="ribbon__row border--bottom">
          <div
            @click="showEPANETControls('RULES')"
            class="ribbon-button ribbon__row--flex"
          >
            <span class="icon">
              <v-icon small>view_headline</v-icon>
            </span>
            <button class="caption">Sterowanie złożone</button>
          </div>
        </div>
      </div>
    </div>

    <div class="group" v-if="!!displaySettings.last_model">
      <div class="container__group--rows">
        <div class="ribbon__row border--bottom">
          <div class="ribbon-button ribbon__row--flex">
            <span class="icon">
              <v-icon>bar_chart</v-icon>
            </span>
            <button
              class="caption"
              @click="showLatestModelling"
              title="Wyświetl wyniki ostatniego modelowania"
            >
              Wyświetl ostatnie modelowanie
            </button>
          </div>
        </div>
        <div class="ribbon__row border--bottom">
          <div class="ribbon-button ribbon__row--flex">
            <span class="caption"
              >Data modelowania:
              {{ displaySettings.last_model.calculation_display_time }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="group" v-else>
      <button class="ribbon-button" @click="showLatestModelling">
        <span class="icon">
          <v-icon>bar_chart</v-icon>
        </span>
        <span class="caption" title="Wyświetl wyniki ostatniego modelowania"
          >Wyświetl ostatnie modelowanie</span
        >
      </button>
    </div>
    <!-- <div class="group">
      <div class="container__group--rows">
        <div class="ribbon__row border--bottom">
          <div class="ribbon-button ribbon__row--flex">
            <button class="caption">Identyfikuj strefy zasilania SUW</button>
          </div>
        </div>
        <div class="ribbon__row border--bottom">
          <div class="ribbon-button ribbon__row--flex">
            <button class="caption">Wyświetl min/max ciśnienie w okresie symulacji</button>
          </div>
        </div>
      </div>
    </div>-->
    <div class="group">
      <button
        class="ribbon-button"
        title="Ustawienia wyświetlania"
        @click="show('displaySettingsModal')"
      >
        <span class="icon">
          <v-icon>settings</v-icon>
        </span>
        <span class="caption">Ust. wyświetlania</span>
      </button>
    </div>
    <div class="group">
      <div class="container__group--rows">
        <div class="ribbon__row border--bottom">
          <div class="ribbon-button ribbon__row--flex" title="Stylizacja węzła">
            <v-select
              label="Węzeł"
              :items="nodesAttributes"
              item-text="label"
              item-value="value"
              height="12"
              class="ribbon--dropdown"
              v-model="nodeAttribute"
            ></v-select>
          </div>
        </div>
        <div class="ribbon__row border--bottom" title="Stylizacja odcinka">
          <div class="ribbon-button ribbon__row--flex">
            <v-select
              label="Odcinki"
              :items="linksAttributes"
              item-text="label"
              item-value="value"
              height="12"
              class="ribbon--dropdown"
              v-model="linkAttribute"
            ></v-select>
          </div>
        </div>
      </div>
    </div>
    <div class="group">
      <div class="container__group--rows">
        <div class="ribbon__row border--bottom">
          <div
            class="ribbon-button ribbon__row--flex"
            title="Parametry modelowania"
          >
            <v-text-field
              label="Krok czasowy symulacji"
              type="number"
              min="1"
              height="12"
              class="ribbon--dropdown"
              v-model="timeStep"
            ></v-text-field>
          </div>
        </div>
        <div class="ribbon__row border--bottom">
          <div
            class="ribbon-button ribbon__row--flex"
            @click="animationAction('play')"
          >
            <span class="icon">
              <v-icon small>{{ !!playModel ? "stop" : "play_arrow" }}</v-icon>
            </span>
          </div>
          <div
            class="ribbon-button ribbon__row--flex"
            @click="animationAction('next')"
          >
            <span class="icon">
              <v-icon small>skip_next</v-icon>
            </span>
          </div>
          <div
            class="ribbon-button ribbon__row--flex"
            @click="animationAction('previous')"
          >
            <span class="icon">
              <v-icon small>skip_previous</v-icon>
            </span>
          </div>
          <!--<div class="ribbon-button ribbon__row--flex">
            <span class="icon">
              <v-icon small>playlist_add</v-icon>
            </span>
          </div>-->
        </div>
      </div>
    </div>
    <!-- <div class="group">
      <CommonComp />
    </div> -->
    <div class="more-hidden" id="showMore">
      <a href="#">
        <span class="fa fa-ellipsis-h"></span>
      </a>
      <ul class="hidden-menu"></ul>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
// import CommonComp from "../../shared/CommonComp";
import vueCustomScrollbar from "vue-custom-scrollbar";

import Overlay from "ol/Overlay.js";

/*import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import each from "lodash/each";
import flatten from "lodash/flatten";
import sortBy from "lodash/sortBy";
import min from "lodash/min";
import max from "lodash/max";
import sortedUniq from "lodash/sortedUniq";
import round from "lodash/round";

mixin(_, {
  chain,
  map,
  each,
  flatten,
  sortBy,
  min,
  max,
  sortedUniq,
  round,
});
_.value = value;
_.prototype.value = value;*/

export default {
  components: {
    // CommonComp,
    vueCustomScrollbar
  },
  data: () => ({
    isVirtualRecipientsLoaded: false,
    linksAttributes: [
      { value: "null", label: "Brak atrybutu" },
      { value: "flow", label: "Natężenie przepływu" },
      { value: "friction", label: "Współczynnik tarcia" },
      { value: "headloss", label: "Jednostkowy wskaźnik strat ciśnienia" },
      { value: "quality", label: "Wiek wody" },
      { value: "reactionrate", label: " Natężenie reakcji" },
      /*{value: 'status', label: "Status przewodu"},*/
      { value: "velocity", label: "Prędkość przepływu" }
    ],
    nodesAttributes: [
      { value: "null", label: "Brak atrybutu" },
      {
        value: "demand",
        label: "Obliczone zużycie w danym momencie symulacji"
      },
      { value: "head", label: "Wysokość linii ciśnienia" },
      { value: "pressure", label: "Wartość ciśnienia" },
      { value: "quality", label: "Wiek wody" }
    ],
    timeStep: 1,
    nodeAttribute: "null",
    linkAttribute: "null",
    includeParameters: false
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    map() {
      return this.$store.getters.getMap;
    },
    displaySettings() {
      return this.$store.getters.getModelWatDisplaySettings;
    },
    modelWatTimeStep() {
      return this.$store.getters.getModelWatTimeStep;
    }
  },
  watch: {
    linkAttribute(_new, _old) {
      const displaySettings = JSON.parse(JSON.stringify(this.displaySettings));
      displaySettings.links.attribute = _new;
      this.$store.commit("setModelWatDisplaySettings", displaySettings);
    },
    nodeAttribute(_new, _old) {
      const displaySettings = JSON.parse(JSON.stringify(this.displaySettings));
      displaySettings.nodes.attribute = _new;
      this.$store.commit("setModelWatDisplaySettings", displaySettings);
    },
    timeStep(_new, _old) {
      this.$store.commit("setModelWatTimeStep", _new);
    }
  },
  methods: {
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    showEPANETControls(level) {
      this.$root.$emit("setEPANETTitle", level);
      this.show("epanetControlsModal");
    },
    doModelling() {
      this.$modal.show(
        {
          template: `
            <div id="modellingNameModal" style="padding: 20px;">
              {{ text }}
              <v-form>
                  <v-layout>
                    <v-flex
                      xs12
                    >
                      <v-text-field
                        v-model="modellingName"
                        name="modellingName"
                        label="Nazwa modelowania"
                        :rules="modellingNameRules"
                        :error-messages="(modellingName.length < 1) ? ['Nie podano nazwy modelowania'] : []"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
              </v-form>

              <v-btn
                color="red"
                dark
                style="float: right"
                :class="{btnInactive: isInactive}"
                @click="closeModal"
              >
                ANULUJ
              </v-btn>
              <v-btn
                color="rgb(42, 87, 154)"
                dark
                style="float:right"
                id="submit-btn"
                :class="{btnInactive: isInactive}"
                @click="modellingStart"
              >
                MODELUJ
              </v-btn>
              
            </div>
          `,
          props: ["text"],
          data: () => ({
            modellingName: "",
            modellingNameRules: [v => !!v || "Nazwa modelowania jest wymagana"],
            modellingStatuses: [],
            modellingNetKinds: [],
            includeParameters: false,
            isInactive: false
          }),
          computed: {
            activeModals() {
              return this.$store.getters.getModalsList;
            },
            modelingSettings() {
              return JSON.parse(
                this.$store.getters.getSettings.EPANET_FILTER.replace(/'/g, '"')
              );
            }
          },
          methods: {
            modellingStart() {
              this.closeModal();
              this.isInactive = true;
              let payload = {
                body: {
                  name: this.modellingName,
                  net_kind: this.modelingSettings.netKinds,
                  status: this.modelingSettings.statuses
                }
              };
              this.$root.$emit(
                "showSnackbar",
                "#2a579a",
                `Modelowanie rozpoczęte`
              );
              this.$store.dispatch("doModelling", payload).then(r => {
                if (r.status == 200 || r.status == 201) {
                  this.$root.$emit(
                    "showSnackbar",
                    "success",
                    `Sukces, wykonano analizę i zapisano jej wynik w bazie`
                  );
                } else if (r.status == 400) {
                  this.show("ModellingError");
                  this.$root.$emit("showModellingReport", r.data.report);
                  this.$root.$emit("showSnackbar", "red", `${r.data.message}`);
                } else {
                  this.$root.$emit("showSnackbar", "red", `${r.data.message}`);
                }
              });
            },
            show(title) {
              if (this.activeModals.indexOf(title) == -1) {
                this.$store.commit("addModal", title);
                this.$modal.show(title);
              }
            },
            closeModal() {
              this.$modal.hide("modellingNameModal");
            }
          },
          mounted() {
            const today = new Date();
            let dd = today.getDate();
            let mm = today.getMonth() + 1; //January is 0!
            let hh = today.getHours();
            let minutes = today.getMinutes();

            const yyyy = today.getFullYear();

            if (dd < 10) dd = `0${dd}`;
            if (mm < 10) mm = `0${mm}`;
            if (hh < 10) hh = `0${hh}`;
            if (minutes < 10) minutes = `0${minutes}`;

            let date = dd + "." + mm + "." + yyyy;
            let time = hh + ":" + minutes;
            this.modellingName = `Analiza z ${date}, ${time}`;
          }
        },
        {
          text:
            "Poniżej wpisz własną nazwę dla modelowania lub zostaw wybraną domyślnie."
        },
        {
          height: "auto",
          name: "modellingNameModal"
        },
        {
          "before-close": event => {
            this.modellingName = "";
            this.includeParameters = false;
            this.isInactive = false;
          }
        }
      );
    },
    showLatestModelling() {
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        `Pobieranie ostatniego modelowania`,
        20000
      );
      this.$store.dispatch("showLatestModelling").then(r => {
        if (r.status === 200) {
          const displaySettings = JSON.parse(
            JSON.stringify(this.displaySettings)
          );

          displaySettings.last_model = {
            periods: r.data.periods,
            calculation_time: r.data.calculation_time,
            calculation_display_time: new Date(
              r.data.calculation_time
            ).toLocaleString(),
            ranges: {
              links: {
                flow: {
                  range: [25, 50, 75, 100]
                },
                friction: {
                  range: [0.001, 0.01, 0.1, 1]
                },
                headloss: {
                  range: [0.03, 0.05, 0.08, 0.1]
                },
                quality: {
                  range: [3, 6, 12, 24]
                },
                reactionrate: {
                  range: [0.1, 0.5, 1, 5]
                },
                velocity: {
                  range: [0.01, 0.1, 1, 2]
                }
              }, //r.data.links_ranges,
              nodes: {
                demand: {
                  range: [25, 50, 75, 100]
                },
                head: {
                  range: [25, 50, 75, 100]
                },
                pressure: {
                  range: [25, 50, 75, 100]
                },
                quality: {
                  range: [3, 6, 12, 24]
                }
              } //r.data.nodes_ranges
            }
          };

          this.$store.commit("setModelWatDisplaySettings", displaySettings);
          this.timeStep = 1;

          this.$root.$emit(
            "addModelWat",
            r.data.links_geojson,
            r.data.nodes_geojson
          );
        } else {
          this.$root.$emit("showSnackbar", "red", `${r}`);
        }
      });
    },
    checkGraph() {
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Trwa sprawdzanie poprawności grafu sieci"
      );
      this.$store.dispatch("checkGraph").then(r => {
        if (r.status == 200) {
          if (Object.entries(r.data).length == 0) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              `Nie znaleziono błędów, dane sieci wodociągowej są poprawne`
            );
          } else {
            this.$root.$emit("checkingGraphEnd", r.data);
            this.show("CheckGraphResults");
          }
        } else {
          this.$root.$emit("showSnackbar", "red", `${r}`);
        }
      });
    },
    exportGraph() {
      this.$store.dispatch("getSingleSettings", "EPANET_FILTER").then(r => {
        if (!r) {
          const settingsPayload = {
            EPANET_FILTER: {
              statuses: ["Istniejący czynny", "Nieudokumentowane"],
              netKinds: ["Sieć wodociągowa ogólna"]
            }
          };
          this.$store.dispatch("changeSettings", settingsPayload).then(res => {
            if (res.status != 200) {
              alert(res);
              this.$root.$emit("showSnackbar", "error", `${res}`);
            } else {
              const parameters = {
                status: ["Istniejący czynny", "Nieudokumentowane"],
                net_kind: ["Sieć wodociągowa ogólna"]
              };
              this.$store.dispatch("exportGraph", parameters).then(res2 => {
                if (res2.status != 200) {
                  alert(res2);
                  this.$root.$emit("showSnackbar", "red", `${res2}`);
                }
              });
            }
            return;
          });
        }
      });

      this.$store.dispatch("getSingleSettings", "EPANET_FILTER").then(r => {
        if (r) {
          r = JSON.parse(r.replace(/\'/g, '"'));
          this.modellingStatuses = r.statuses;
          this.modellingNetKinds = r.netKinds;

          this.$root.$emit(
            "showSnackbar",
            "#2a579a",
            "Trwa eksportowanie sieci"
          );
          const parameters = {
            status: this.modellingStatuses,
            net_kind: this.modellingNetKinds
          };
          this.$store.dispatch("exportGraph", parameters).then(r => {
            if (r.status != 200) {
              this.$root.$emit("showSnackbar", "red", `${r}`);
            }
          });
        }
      });
    },
    includeParametersChanged(data) {
      this.includeParameters = data;
    },

    animationAction(type) {
      if (!this.displaySettings.last_model) {
        return;
      }
      switch (type) {
        case "play":
          if (this.playModel) {
            clearInterval(this.playModel);
            this.playModel = false;
            this.$forceUpdate();
          } else {
            this.playModel = setInterval(() => {
              if (this.timeStep <= this.displaySettings.last_model.periods) {
                this.timeStep++;
              } else {
                this.timeStep = 1;
              }
            }, 5000);
            this.$forceUpdate();
          }
          break;
        case "next":
          if (this.playModel) {
            clearInterval(this.playModel);
            this.playModel = false;
            this.$forceUpdate();
          }
          if (this.timeStep <= this.displaySettings.last_model.periods) {
            this.timeStep++;
          }
          break;
        case "previous":
          if (this.playModel) {
            clearInterval(this.playModel);
            this.playModel = false;
            this.$forceUpdate();
          }
          if (this.timeStep > 1) {
            this.timeStep--;
          }
          break;
      }
    }
  },
  created() {
    this.nodeAttribute = this.displaySettings.nodes.attribute;
    this.linkAttribute = this.displaySettings.links.attribute;
    this.timeStep = this.modelWatTimeStep;
    this.playModel = false;
  },
  mounted() {
    const self = this;

    let container = document.getElementById("popup");
    let content = document.getElementById("popup-content");
    let overlay = new Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });
    this.map.addOverlay(overlay);

    let layersArr = this.map.getLayers().getArray();
    for (let i in layersArr) {
      if (layersArr[i].values_.name == "virtualRecipientsLayer") {
        self.isVirtualRecipientsLoaded = true;
      }
    }
    if (self.isVirtualRecipientsLoaded === false) {
      this.$root.$emit(
        "showSnackbar",
        "rgb(42, 87, 154)",
        "Trwa pobieranie informacji o projektowanych odbiorcach"
      );
      this.$store.dispatch("getVirtualRecipients").then(success => {
        if (success) {
          self.$root.$emit("drawVirtualRecipients");
        } else {
          self.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas ładowania projektowanych odbiorców wystąpił błąd"
          );
        }
      });
    }

    this.map.on("singleclick", evt => {
      if (self.isClickable) {
        document.getElementById("map").style.cursor = "default";
        self.pointCoords = evt.coordinate;
        // self.show("addScadaPointModal");
      }
      self.isClickable = false;

      let feature = self.map.forEachFeatureAtPixel(evt.pixel, feature => {
        return feature;
      });
      if (feature) {
        if (!feature.values_.hasOwnProperty("address")) {
          overlay.setPosition(undefined);
          return;
        }
        let coordinates = feature.getGeometry().getCoordinates();
        this.pointID = feature.get("recipientID");
        this.$root.$emit("editProjectedReceiver", [
          feature.get("properties"),
          coordinates,
          feature["id_"]
        ]);
        this.show("addProjectedReceiverModal");
      } else {
        overlay.setPosition(undefined);
        if (document.getElementById("scadaModalOpener")) {
          document
            .getElementById("scadaModalOpener")
            .removeEventListener("click", () => {
              this.show("scadaPointCard");
            });
        }
        return;
      }
    });

    this.$root.$on("includeParametersChanged", this.includeParametersChanged);
  },
  beforeDestroy() {
    if (this.playModel) {
      clearInterval(this.playModel);
    }
    this.$root.$emit("clearModelWat");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/modelWat/ModelWat.vue